var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockLocked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.255 25.0394L40.6842 25.0526C40.6794 20.1307 36.6645 16.1413 31.7357 16.1587C26.8088 16.1762 22.8007 20.1939 22.8055 25.1158L19.2285 25.1285C19.2217 18.2361 24.832 12.6101 31.7322 12.5857C38.6343 12.5613 44.2483 18.147 44.255 25.0394Z",
    fill: "#C9C9D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.255 25.0394L44.2627 32.1812L19.2357 32.2703L19.2285 25.1285L22.8055 25.1158L22.811 32.2576L40.6875 32.1939L40.6805 25.0524L44.255 25.0394Z",
    fill: "#C9C9D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8182 45.8721H30.1818V39.1203H33.8182V45.8721Z",
    fill: "#C9C9D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 28.9927V55.9997H52V28.9927H12ZM15.6364 52.6239H48.3636V32.3686H15.6364V52.6239Z",
    fill: "#C9C9D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLocked);
export default __webpack_public_path__ + "static/media/lock_locked.74558e7d1bc8e471c11252fe12163eed.svg";
export { ForwardRef as ReactComponent };